import React, { Component } from 'react'

// ui
import { Spin } from 'antd'
import { FaCheck, FaTimes, FaPlus, FaSave } from 'react-icons/fa'
import { Form, Input, Switch, Upload, Row, Col, Checkbox } from 'antd'
import Button from '../../components/uielements/button'

// redux
import { connect } from 'react-redux'
import roleActions from '../../redux/qbrole/actions'

class RoleInfoForm extends Component {

    // life cycle
    componentWillReceiveProps(nextProps) {
        if (nextProps.role !== this.props.role) {
            const { form, role } = nextProps
            form.setFieldsValue({ name: role.role_name })
        }
    }

    componentDidMount() {
        const { form, role } = this.props
        form.setFieldsValue({ name: role.role_name })
    }

    // validate 
    validateRolename = async (rule, value, callback) => {
        const { user } = this.props

        // if (value) {
        //     if (user.uid === -1) {
        //         let response = await checkUsername(value)
        //         if (response.error.code === 200 && response.data === true)
        //             callback('Tên đăng nhập đã tồn tại')
        //     }
        // }

        callback()
    }


    // event
    onSubmit = e => {
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.saveCurrentRole()
                this.props.dismiss()
            }
        })
    }

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form
        const { qbactions, role } = this.props

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        }


        return (
            <Form {...formItemLayout} onSubmit={this.onSubmit}>
                <Form.Item label="Tên phân quyền" hasFeedback>
                    {getFieldDecorator('name', {
                        rules: [
                            {
                                required: true,
                                message: 'Xin mời nhập tên phân quyền',
                            },
                            {
                                validator: this.validateRolename
                            }
                        ],
                    })(
                        <Input
                            onChange={value => {
                                this.props.updateCurrentRole({
                                    role_name: value.target.value,
                                })
                            }}
                        />
                    )}
                </Form.Item>

                <Form.Item wrapperCol={{ xs: { span: 24, offset: 24 }, sm: { span: 16, offset: 8 } }}>
                    <Button
                        size="large"
                        onClick={() => this.props.updateAllAction(true)}
                        style={{
                            backgroundColor: '#f2f2f2',
                            marginRight: 5,
                            color: 'black',
                            marginBottom: 5
                        }}
                    >
                        <FaCheck style={{ marginRight: 5 }} />
                        chọn tất cả
                    </Button>

                    <Button
                        size="large"
                        onClick={() => this.props.updateAllAction(false)}
                        style={{ backgroundColor: ' #f2f2f2', color: 'black' }}
                    >
                        <FaTimes style={{ marginRight: 5 }} />
                        Bỏ chọn tất cả
                    </Button>
                </Form.Item>

                {
                    qbactions.map((module, index) => {
                        const _actions = module.actions
                        return (
                            <Form.Item label={module.name}>
                                <Row style={{ width: '100%' }}>
                                    {
                                        _actions.map((action, aindex) => {
                                            let k = 24 / _actions.length
                                            let isChecked = role.action_ids.includes(action.type)

                                            return (
                                                <Col xl={k} ls={k} lg={k} xxl={k} style={{ textAlign: 'center', color: 'black' }}>
                                                    <div style={{ marginBottom: 1, padding: 0 }}>
                                                        <div style={{ lineHeight: 1 }}>
                                                            {
                                                                action.name
                                                            }
                                                        </div>
                                                        <Switch style={{ marginLeft: 5 }}  checked={isChecked} onChange={(value) => {
                                                            this.props.updateAction(action.type, value)
                                                        }} />
                                                    </div>
                                                </Col>
                                            )
                                        })
                                    }
                                </Row>
                            </Form.Item>
                        )
                    })
                }

                <Form.Item wrapperCol={{ span: 15, offset: 11 }}>
                    <Button
                        size="large"
                        htmlType="submit"
                        style={{
                            backgroundColor: 'lightgreen',
                            marginRight: 5,
                            color: 'black',
                        }}
                    >
                        <FaSave style={{ marginRight: 5 }} />
                        Lưu
                    </Button>

                    <Button
                        size="large"
                        onClick={() => this.props.onCancel()}
                        style={{ backgroundColor: ' #ffcccc', color: 'black' }}
                    >
                        <FaTimes style={{ marginRight: 5 }} />
                        Huỷ
                    </Button>
                </Form.Item>
            </Form>
        )
    }
}

// register form
const RoleFormRegisterComplete = Form.create({ name: 'roleinfo' })(
    RoleInfoForm
)

// redux
const mapStateToProps = state => {
    return {
        role: state.qbrole.currentRole,
        qbactions: state.qbrole.qbactions
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateCurrentRole: role => {
            dispatch(roleActions.action.updateCurrentRole(role))
        },
        updateAction: (actionId, status) => {
            dispatch(roleActions.action.updateAction(actionId, status))
        },
        updateAllAction: status => {
            dispatch(roleActions.action.updateAllAction(status))
        },
        saveCurrentRole: () => {
            dispatch(roleActions.action.saveCurrentRole())
        },
        dismiss: () => {
            dispatch(roleActions.action.dismissModalCurrentRoleInfo())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RoleFormRegisterComplete)